const defaultContent = "Click on a topic to see the knowledge base content here.";

export default defaultContent;